import { widths } from '../commonDisplayOptions';
import { fieldNames } from '../fields';

export const dataModel = {
    component: String(),
    id: String(),
    width: widths,
};

export const defaults = {
    component: fieldNames.divider,
    width: widths['100'].value
};